
export default function DeleteAccount({ user }){

    const handleDelete=()=>{}

    return(
        <>
            <div className="border-b border-gray-900/10 pb-8">
                <h2 className="text-base font-semibold leading-7 text-gray-900">Supprimer le compte</h2>
                <p className="mt-1 text-sm leading-6 text-gray-600">Vous ne souhaitez plus utiliser notre service ? Vous pouvez supprimer votre compte ici. Cette action n'est pas réversible. Toutes les informations liées à ce compte seront supprimées définitivement.</p>
            </div>
            <div className="mt-6 flex items-center justify-end gap-x-6">
                <button
                    type="button"
                    onClick={handleDelete}
                    className="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500"
                    >
                    Oui, supprimer mon compte
                </button>
            </div>
        </>
    )
}